var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNonTangible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2357_409442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4458 6.95772V7.20772H23.6958H30.3918C32.0951 7.20772 33.4898 8.60239 33.4898 10.3057V30.3937C33.4898 32.097 32.0951 33.4917 30.3918 33.4917H3.60777C1.90444 33.4917 0.509766 32.097 0.509766 30.3937V10.3057C0.509766 8.60239 1.90444 7.20772 3.60777 7.20772H10.3038H10.5538V6.95772V3.60972C10.5538 1.90639 11.9484 0.511719 13.6518 0.511719H20.3478C22.0511 0.511719 23.4458 1.90639 23.4458 3.60972V6.95772ZM13.6518 3.35972H13.4018V3.60972V6.95772V7.20772H13.6518H20.3478H20.5978V6.95772V3.60972V3.35972H20.3478H13.6518ZM30.3918 30.6437H30.6418V30.3937V10.3057V10.0557H30.3918H3.60777H3.35777V10.3057V30.3937V30.6437H3.60777H30.3918Z",
    fill: "#B0C1DB",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2947 19.0348H15.5447V18.7848V14.1523H18.4547V18.7848V19.0348H18.7047H23.5697V21.7898H18.7047H18.4547V22.0398V26.6723H15.5447V22.0398V21.7898H15.2947H10.4297V19.0348H15.2947Z",
    fill: "#B0C1DB",
    stroke: "white",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2357_409442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.48,
    height: 33.48,
    fill: "white",
    transform: "translate(0.259766 0.261719)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonTangible);
export default __webpack_public_path__ + "static/media/non-tangible.b92681e0.svg";
export { ForwardRef as ReactComponent };